





































import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import Card from '@/components/Card.vue';
import Modal from '@/components/Modal.vue';
import store from '@/store';

@Component({
  components: {
    Card,
    Modal,
  },
  computed: mapState([
    'entries',
  ]),
})
export default class Main extends Vue {
  entries!: Array<{API: string; Category: string}>;

  filter() {
    const { entries } = this;
    const tags = store.state.filterTags;

    // filter by tags first
    if (tags.length > 0) {
      return entries.filter((entry) => tags.includes(entry.Category));
    }
    return entries;
  }

  // eslint-disable-next-line class-methods-use-this
  showModal() {
    const modal = document.querySelector('#filter-modal') as Element;
    modal.classList.add('is-active');
  }
}
